export default __webpack_public_path__ + "static/media/curriculum-download-icon.9ec61219.svg";